import { makeRequest } from './makeRequest';
import { useQuery } from '@tanstack/react-query';

export type GetProjectOrganizationCollaboratorsData = {
	statusCode: string;

	project: {
		organizations: {
			organizationId: number;
			organizationName: string;
			isDefaultOrg: boolean;
			organizationCollaborators: {
				userId: string;
			}[];
		}[];
	};
};

export const useGetProjectOrganizationCollaboratorsQuery = ({
	projectId
}: {
	projectId: string;
}) => {
	return useQuery({
		queryKey: ['projectOrganizationCollaborators', projectId],
		queryFn: () =>
			makeRequest<GetProjectOrganizationCollaboratorsData>({
				method: 'getProjectOrganizationCollaborators',
				service: 'projects',
				data: {
					project: {
						projectId: parseInt(projectId)
					}
				}
			})
	});
};
